import styled from 'styled-components'

import LocationAddFormUnstyled from 'Containers/Form/City/Locations/LocationAdd/unstyled'

export const LocationAddForm = styled(LocationAddFormUnstyled)`
  margin: 0 -15px;

  .row {
    margin: 0 0 30px 0;
  }

  .row:last-child {
    margin: 0;
  }
`
